import axios from "../axios";
import { handleFileDownload } from "../../utils";

const api = {
  getSupplierUsers(paramsString, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/administration/supplier/users?${paramsString}`, config).then(({ data }) => data);
  },
  createSupplierUser(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/administration/supplier/users", data, headers).then(({ data }) => data);
  },
  updateSupplierUser({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/administration/supplier/users/${id}`, data, headers).then(({ data }) => data);
  },
  resendSupplierInvitation(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/administration/supplier/users/${id}/invitation`, {}, headers).then(({ data }) => data);
  },
  activateUser(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.patch(`/administration/supplier/users/${id}/status`, { "status": "ACTIVE" }, headers).then(({ data }) => data);
  },
  deactivateUser(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.patch(`/administration/supplier/users/${id}/status`, { "status": "DEACTIVATED" }, headers).then(({ data }) => data);
  },
  getPaginatedSuppliersWithTiers(paramsString, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/suppliers/tiers?${paramsString}`, config).then(({ data }) => data);
  },
  manageSupplierCompany(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put("/suppliers", data, headers).then(({ data }) => data);
  },
  manageSupplierStatus({ id, status }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.patch(`/suppliers/${id}/status`, { "status": status }, headers).then(({ data }) => data);
  },
  getSupplierLocations(paramsString, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/suppliers/locations?${paramsString}`, config).then(({ data }) => data);
  },
  createSupplierLocation(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/suppliers/locations", data, headers).then(({ data }) => data);
  },
  updateSupplierLocation({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/suppliers/locations/${id}`, data, headers).then(({ data }) => data);
  },
  deleteSupplierLocation(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/suppliers/locations/${id}`, headers).then(({ data }) => data);
  },
  downloadSupplierLocationsTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/suppliers/locations/template`, config).then(({ data, headers }) => {
      handleFileDownload(data, headers, "Supplier_locations_template");
    });
  },
  importSupplierLocations({ data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/suppliers/locations/import", data, headers).then(({ data }) => data);
  },
  exportSupplierCompanies(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/suppliers/export", config).then(({ data, headers }) => {
      handleFileDownload(data, headers, "Suppliers_list_export");
    });
  },
  getSupplierCountWithCompletedQuestionnaire(paramsString, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`suppliers/reports/engagement/suppliers-by-assignment-completion?${paramsString}`, config).then(({ data }) => data);
  },
};

export default api;